/**
 * Initials for the signed-in person, from whichever of display name or address
 * is present.
 *
 * Shared rather than defined beside one of its callers: identity now appears in
 * two places — the workspace sidebar and the front door — and initials computed
 * two different ways for the same person is the kind of drift nobody notices
 * until a screenshot shows both at once.
 */
export function displayNameOf(displayName: string, email: string): string {
  /* The same fallback `initialsOf` makes, and for the same reason: a display name
     of whitespace is truthy, so `displayName || email` renders a blank line while
     the initials beside it are correctly derived from the address. Trimming first
     is what keeps the two from disagreeing about who someone is. */
  return displayName.trim() || email.trim();
}

export function initialsOf(displayName: string, email: string): string {
  const source = displayName.trim() || email.trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
